/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Rpe_Out_Of_RangeInputs */

const en_us2_workout_rpe_out_of_range = /** @type {(inputs: Workout_Rpe_Out_Of_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The effort has to be between 1 and 10.`)
};

const pt_br2_workout_rpe_out_of_range = /** @type {(inputs: Workout_Rpe_Out_Of_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O esforço precisa estar entre 1 e 10.`)
};

const es_419_workout_rpe_out_of_range = /** @type {(inputs: Workout_Rpe_Out_Of_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El esfuerzo tiene que estar entre 1 y 10.`)
};

const pt_pt2_workout_rpe_out_of_range = /** @type {(inputs: Workout_Rpe_Out_Of_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O esforço tem de estar entre 1 e 10.`)
};

const fr_fr2_workout_rpe_out_of_range = /** @type {(inputs: Workout_Rpe_Out_Of_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'effort doit être compris entre 1 et 10.`)
};

const de_de2_workout_rpe_out_of_range = /** @type {(inputs: Workout_Rpe_Out_Of_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Anstrengung muss zwischen 1 und 10 liegen.`)
};

const it_it2_workout_rpe_out_of_range = /** @type {(inputs: Workout_Rpe_Out_Of_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lo sforzo deve essere tra 1 e 10.`)
};

/**
* | output |
* | --- |
* | "The effort has to be between 1 and 10." |
*
* @param {Workout_Rpe_Out_Of_RangeInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_rpe_out_of_range = /** @type {((inputs?: Workout_Rpe_Out_Of_RangeInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Rpe_Out_Of_RangeInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_rpe_out_of_range(inputs)
	if (locale === "es-419") return es_419_workout_rpe_out_of_range(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_rpe_out_of_range(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_rpe_out_of_range(inputs)
	if (locale === "de-DE") return de_de2_workout_rpe_out_of_range(inputs)
	if (locale === "it-IT") return it_it2_workout_rpe_out_of_range(inputs)
	return en_us2_workout_rpe_out_of_range(inputs)
});
export { workout_rpe_out_of_range as "workout.rpe_out_of_range" }